/**
 * Utilidades para manejo de imágenes en la aplicación
 */

/**
 * Resuelve la URL completa de una imagen, manejando tanto URLs absolutas como relativas
 * @param imageUrl - URL de la imagen (puede ser absoluta o relativa)
 * @returns URL completa de la imagen o undefined si no hay imagen
 */
export const resolveImageUrl = (imageUrl?: string): string | undefined => {
  if (!imageUrl || imageUrl.trim() === '') {
    return undefined;
  }

  // Si la URL ya es absoluta (comienza con http o https), devolverla tal como está
  if (imageUrl.startsWith('http://') || imageUrl.startsWith('https://')) {
    return imageUrl;
  }

  // Si es una URL relativa, concatenar con PUBLIC_URL
  return process.env.PUBLIC_URL + imageUrl;
};

/**
 * Resuelve la URL de la imagen de un speaker
 * @param profilePic - URL de la foto de perfil del speaker
 * @returns URL completa de la imagen o undefined si no hay imagen
 */
export const resolveSpeakerImageUrl = (profilePic?: string): string | undefined => {
  return resolveImageUrl(profilePic);
};
